import { reduce } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from 'react-stripe-elements'
import { Transition } from 'react-transition-group'

import StripeFieldWrapper from 'components/_special/StripeFieldWrapper'
import Icon from 'components/Icon'

import {
  Form,
  BrandWrapper,
  ExpiryBlock,
  CvcBlock,
  Card,
  IconBlock,
} from './styles'

const FIELD_NUMBER = 'number'
const FIELD_EXPIRY = 'expiry'
const FIELD_CVC = 'cvc'
const VISA = 'visa'
const MASTER = 'mastercard'
const AMEX = 'amex'
const KNOWN_BRANDS = [VISA, MASTER, AMEX]
const INVERT_COLORS = [VISA, AMEX]
const SIZES = {
  [VISA]: {
    width: 56,
    height: 19,
  },
  [MASTER]: {
    width: 54,
    height: 40,
  },
  [AMEX]: {
    width: 94,
    height: 35,
  },
}

class CreditCardBlock extends Component {
  constructor(props) {
    super(props)

    this.cvcFieldRef = React.createRef()
    this.state = {
      brand: null,
      isInputLight: false,
      complete: {
        [FIELD_NUMBER]: false,
        [FIELD_EXPIRY]: false,
        [FIELD_CVC]: false,
      },
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { complete } = this.state
    const { onCreditCardCompleteChange } = this.props

    if (complete !== prevState.complete) {
      const isAllComplete = reduce(
        complete,
        (result, isComplete) => result && isComplete,
        true,
      )

      onCreditCardCompleteChange({ complete: isAllComplete })
    }
  }

  handleBrand = ({ brand }) => {
    let safeBrand = null
    let isInputLight = false

    if (KNOWN_BRANDS.indexOf(brand) > -1) {
      safeBrand = brand
      isInputLight = INVERT_COLORS.indexOf(brand) > -1
    }

    this.setState({
      brand: safeBrand,
      isInputLight,
    })
  }

  handleCompleteChange = ({ id, isComplete }) => {
    this.setState(
      {
        complete: {
          ...this.state.complete,
          [id]: isComplete,
        },
      },
      () => {
        if (
          this.state.complete[FIELD_NUMBER] &&
          this.state.complete[FIELD_EXPIRY] &&
          !this.state.complete[FIELD_CVC]
        ) {
          this.cvcFieldRef.current._element.focus()
        }
      },
    )
  }

  render() {
    const { onSubmit, btnCanMakePayment } = this.props
    const { brand, isInputLight } = this.state

    const iconWidth = brand ? `${SIZES[brand].width}px` : 'auto'
    const iconHeight = brand ? `${SIZES[brand].height}px` : 'auto'

    return (
      <Form onSubmit={onSubmit} cardType={brand}>
        <Card isFront={true} cardType={brand}>
          <Transition timeout={300} in={!!brand}>
            {state => (
              <BrandWrapper {...{ state }}>
                <IconBlock {...{ iconWidth, iconHeight }}>
                  <Icon id={`pay_${brand}`} />
                </IconBlock>
              </BrandWrapper>
            )}
          </Transition>

          <div>
            <StripeFieldWrapper
              id={FIELD_NUMBER}
              isLight={isInputLight}
              StripeField={CardNumberElement}
              label="Card number"
              placeholder="0000 0000 0000 0000"
              onBrandDetermined={this.handleBrand}
              onFiledCompleteChange={this.handleCompleteChange}
              onReady={el => !btnCanMakePayment && el.focus()}
            />
          </div>
          <ExpiryBlock>
            <StripeFieldWrapper
              id={FIELD_EXPIRY}
              isLight={isInputLight}
              StripeField={CardExpiryElement}
              label="MM/YY"
              placeholder="00/00"
              onFiledCompleteChange={this.handleCompleteChange}
            />
          </ExpiryBlock>
        </Card>
        <Card isBack={true} cardType={brand}>
          <CvcBlock>
            <StripeFieldWrapper
              id={FIELD_CVC}
              isLight={isInputLight}
              StripeField={CardCVCElement}
              label="CVC"
              placeholder="000"
              onFiledCompleteChange={this.handleCompleteChange}
              cvcFieldRef={this.cvcFieldRef}
            />
          </CvcBlock>
        </Card>
      </Form>
    )
  }
}

CreditCardBlock.propTypes = {
  onCreditCardCompleteChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  btnCanMakePayment: PropTypes.bool.isRequired,
}

export default CreditCardBlock
